import { Box } from "@mui/material";

import useHeaderHeight from "../../hooks/useHeaderHeight";

const IdAnchor = (props: { id: string }) => {
  const headerHeight = useHeaderHeight();
  return (
    <div style={{ position: "relative" }}>
      <Box
        sx={{
          opacity: 0,
          position: "absolute",
          top: {
            xs: -1 * (headerHeight + 40) + "px",
            md: -1 * (headerHeight + 80) + "px",
          },
        }}
        id={props.id}
      ></Box>
    </div>
  );
};

export default IdAnchor;
